import React from 'react';
import { Box, Typography, useTheme, alpha } from '@mui/material';

interface CustomDateHeaderProps {
  label: string;
  date: Date;
}

export const CustomDateHeader: React.FC<CustomDateHeaderProps> = ({ label, date }) => {
  const theme = useTheme();
  const isToday = new Date().toDateString() === date.toDateString();
  const parts = label.split(' ');
  const dayNum = parts[0];
  const dayName = parts[1] || '';

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      py: 1,
      px: 1,
      minHeight: 64,
      gap: 0.25,
      width: '100%',
      transition: 'background-color 0.2s ease',
    }}>
      <Typography
        variant="caption"
        sx={{
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.08em',
          color: isToday ? 'primary.main' : 'text.secondary',
          fontSize: '0.7rem',
          lineHeight: 1,
        }}
      >
        {dayName}
      </Typography>
      <Box
        sx={{
          fontWeight: 800,
          fontSize: '1.1rem',
          lineHeight: 1,
          color: isToday ? '#fff' : 'text.primary',
          bgcolor: isToday ? theme.palette.primary.main : 'transparent',
          width: 32,
          height: 32,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '50%',
          fontFamily: theme.typography.fontFamily,
          transition: 'all 0.2s ease',
          boxShadow: isToday ? `0 4px 10px ${alpha(theme.palette.primary.main, 0.3)}` : 'none',
        }}
      >
        {dayNum}
      </Box>
    </Box>
  );
};
